import { Component } from '@angular/core';

/**
 * Standalone 用 License Agreement 文章コンポーネント。
 */
@Component({
    selector: 'app-standalone-license-texts',
    templateUrl: './standalone-license-texts.component.html',
    styleUrls: ['./standalone-license-texts.component.scss'],
    standalone: false
})
export class StandaloneLicenseTextsComponent {
  /** Open Source Software の URL。 */
  public readonly openSourceSoftwareUrl: string = 'https://www.olympus-ims.com/en/support/open-source-software/';
}
